import { Toaster } from 'sonner';

export function AppToaster() {
  return <Toaster richColors />;
}
